import { Typography } from "@mui/material";
import PropTypes from "prop-types";

import Placeholder from "components/Placeholder";

const Title = ({ title, isLoading }) => {
  if (isLoading) {
    return <Placeholder variant="text" width={210} height={30} data-testid="title-placeholder" />;
  }

  return (
    <Typography component="h1" variant="h2" align="center">
      {title}
    </Typography>
  );
};

Title.propTypes = {
  title: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default Title;
